module.exports = __webpack_public_path__ + "static/image/company/pc/visual@3x.jpg?566254fe";